import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        brand: "border border-transparent bg-brand-accent text-brand-ink font-semibold shadow-none hover:bg-brand-accent-hover",
        brandOutline:
          "border border-brand-ink/12 bg-background text-brand-ink font-medium shadow-none hover:border-brand-ink/20 hover:bg-brand-ink/[0.025]",
        brandAccentOutline:
          "border border-brand-ink/12 bg-background text-brand-ink font-medium shadow-none hover:border-brand-accent/40 hover:bg-brand-accent/10",
        brandDashed:
          "border border-dashed border-brand-ink/20 bg-background text-brand-ink/50 font-medium shadow-none hover:border-brand-accent/50 hover:bg-brand-accent/5 hover:text-brand-ink",
        brandGhost:
          "text-brand-ink/40 shadow-none hover:bg-brand-ink/[0.04] hover:text-brand-ink",
        brandDestructiveGhost:
          "text-brand-ink/40 shadow-none hover:bg-destructive/5 hover:text-destructive",
        utility:
          "text-muted-foreground shadow-none hover:bg-accent hover:text-foreground dark:hover:bg-accent/50",
        utilityActive:
          "bg-primary/10 text-primary shadow-none hover:bg-primary/15 hover:text-primary",
        quietDestructive:
          "text-muted-foreground shadow-none hover:bg-destructive/10 hover:text-destructive",
        destructive:
          "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline:
          "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 min-h-10 px-4 py-2 has-[>svg]:px-3",
        xs: "h-10 min-h-10 rounded-md gap-1 px-3 text-xs md:h-6 md:min-h-6 md:px-2 md:text-[0.6875rem] has-[>svg]:px-2 md:has-[>svg]:px-1.5",
        sm: "h-10 min-h-10 gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 min-h-10 px-6 has-[>svg]:px-4",
        iconXs: "size-10 min-h-10 min-w-10 md:size-7 md:min-h-7 md:min-w-7",
        iconMd: "size-10 min-h-10 min-w-10",
        icon: "size-10 min-h-10 min-w-10",
        iconSm: "size-10 min-h-10 min-w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
